import React from "react";
import logo from "@Images/parqour-logo.svg";
import LangToggle from "@UI/kit/LangToggle/LangToggle";
import AppStore from "@Images/payments/AppStore.png";
import GooglePlay from "@Images/payments/GooglePlay.png";
import Rights from "@UI/kit/Rights/Rights";
import { useTranslation } from "react-i18next";

const FormContainer = ({ children, title, withApps, withAppDescription }) => {
  const { t } = useTranslation();

  return (
    <div className="mt-5 flex min-h-screen w-full flex-col items-center justify-between p-4 xs:mt-0">
      <div className="flex flex-grow flex-col items-center justify-center">
        <img
          src={logo}
          alt={"logo"}
          className="absolute left-3 top-3 mb-5 h-[17px] w-[67px] xs:static xs:h-[34px] xs:w-[134px]"
        />
        {title}
        <div className="absolute right-6 top-3">
          <LangToggle />
        </div>
        <div className="flex w-full max-w-[532px] flex-col items-center space-y-4 rounded-2xl border border-form bg-white px-4 py-4 xs:px-[66px] xs:py-[45px] sm:w-[532px]">
          {children}
        </div>
      </div>

      {withAppDescription && (
        <div className="mb-6 mt-5 w-[285px] rounded-lg bg-[#F6F8FA] px-4 py-2">
          <p className="text-xs">{t("download_app_description")}</p>
        </div>
      )}

      {withApps && (
        <div className="mb-5 mt-5 flex space-x-4">
          <a href="https://play.google.com/store/search?q=parqour&c=apps" target="_blank">
            <img src={GooglePlay} alt="Google Play" />
          </a>
          <a href="https://apps.apple.com/us/app/parqour/id1612020104">
            <img src={AppStore} alt="App Store" />
          </a>
        </div>
      )}
      <div className="mt-auto">
        <Rights />
      </div>
    </div>
  );
};

export default FormContainer;
